import type { Product as ProductService } from '@inhouse-market/sdk';

export interface ProductPricing {
  finalPriceInCents: number;
  hasActivePromotion: boolean;
  isInSale: boolean;
  priceListInCents: number;
}

export interface PlanogramPricingSource {
  planogramPromotion?: ProductService.PlanogramPromotion | null;
  price_final_in_cents: number | string;
  price_list_in_cents: number | string;
}

export const getProductPricing = (item: PlanogramPricingSource): ProductPricing => {
  const priceListInCents = Number(item?.price_list_in_cents ?? 0);
  const promotion = item?.planogramPromotion;
  const hasActivePromotion = promotion?.status === 'active';
  const promotionPriceInCents = Number(promotion?.priceInCents);
  const fallbackFinalPriceInCents = Number(item?.price_final_in_cents ?? 0);
  const finalPriceInCents = hasActivePromotion && Number.isFinite(promotionPriceInCents)
    ? promotionPriceInCents
    : fallbackFinalPriceInCents;

  return {
    finalPriceInCents,
    hasActivePromotion,
    isInSale: finalPriceInCents < priceListInCents,
    priceListInCents,
  };
};
